import { Stack, useTheme } from "@mui/material";
import { Icon } from "@iconify/react";

const ScrollToTopButton = ({ onClick }: { onClick: () => void }) => {
  const theme = useTheme();
  return (
    <Stack
      onClick={onClick}
      sx={{
        position: "fixed",
        bottom: 20,
        right: 20,
        backgroundColor: theme.palette.primary.darker,
        color: "white",
        borderRadius: "50%",
        width: 50,
        height: 50,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: 3,
        cursor: "pointer",
        zIndex: 1000,
      }}
    >
      <Icon icon="ic:round-arrow-upward" width={24} height={24} />
    </Stack>
  );
};

export { ScrollToTopButton };
